import { Box, Button, Container, Stack, Typography } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import React from "react";
import { Link } from "react-router-dom";
import { NOME_APP, PRODUCAO_RESTRITA } from "../../shared/env";
import HeaderMenu from "./HeaderMenu";
import IdentificacaoSessao from "./IdentificacaoSessao";
import useSessao from "../../shared/useSessao";
import { identificarAmbiente } from "../../shared/ambiente";

const isProducaoRestrita = PRODUCAO_RESTRITA === "S";

function Header({ maxWidth = "lg" }) {
  const sessao = useSessao();
  const mostrarDestino =
    isProducaoRestrita || identificarAmbiente() !== "Produção";
  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <Toolbar sx={{ minHeight: { xs: 112, sm: 72 }, py: 1 }}>
          <Container maxWidth={maxWidth}>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              justifyContent="space-between"
              spacing={1}
            >
              <Stack
                direction="row"
                alignItems="center"
                sx={{ minWidth: 0, flex: 1 }}
              >
                <Button
                  component={sessao.hasAccess ? Link : "span"}
                  to={sessao.hasAccess ? "/" : undefined}
                  sx={{
                    textTransform: "none",
                    color: "white",
                    fontSize: { xs: "1rem", sm: "1.25rem" },
                    fontWeight: 500,
                    height: 40,
                    justifyContent: "flex-start",
                    maxWidth: "100%",
                    minWidth: 0,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                  }}
                >
                  <Box
                    component="img"
                    src={`${process.env.PUBLIC_URL}/favicon.ico`}
                    alt="Símbolo do eSocial"
                    sx={{
                      width: 30,
                      height: 30,
                      mr: 1.25,
                      flexShrink: 0,
                      objectFit: "contain"
                    }}
                  />
                  <Box
                    component="span"
                    sx={{ overflow: "hidden", textOverflow: "ellipsis" }}
                  >
                    {NOME_APP}
                  </Box>
                </Button>
                {mostrarDestino && (
                  <Typography
                    variant="caption"
                    sx={{
                      ml: 1,
                      opacity: 0.8,
                      display: { xs: "none", md: "block" }
                    }}
                  >
                    eSocial:{" "}
                    {isProducaoRestrita ? "produção restrita" : "produção"}
                  </Typography>
                )}
              </Stack>
              <Stack
                direction="row"
                alignItems="center"
                spacing={1}
                sx={{ minWidth: 0, justifyContent: "space-between" }}
              >
                <IdentificacaoSessao compacta />
                {sessao.hasAccess && <HeaderMenu />}
              </Stack>
            </Stack>
          </Container>
        </Toolbar>
      </AppBar>
    </>
  );
}

export default Header;
